import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../../core/entities';

interface UserState {
  users: User[];
  errorMessage?: string;
  validatePassword: boolean;
  oldPassword?: string;
}

const initialState: UserState = {
  users: [],
  errorMessage: undefined,
  validatePassword: false,
  oldPassword: '',
};

export const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onSetUsers: (state, action) => {
      state.users = action.payload;
      state.errorMessage = undefined;
    },
    onSetUser: (state, action) => {
      state.users = [...state.users, action.payload];
      state.errorMessage = undefined;
    },
    clearErrorMessage: (state) => {
      state.errorMessage = undefined;
    },
    updateUser: (state, action: PayloadAction<User>) => {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    toggleValidatePassword: (state) => {
      state.validatePassword = !state.validatePassword;
    },
    setOldPassword: (state, action: PayloadAction<string>) => {
      state.oldPassword = action.payload;
    },
  },
});

export const {
  onSetUsers,
  onSetUser,
  updateUser,
  clearErrorMessage,
  toggleValidatePassword,
  setOldPassword,
} = userSlice.actions;
